export default "__VITE_ASSET__D8TlThgc__"